module.exports = __webpack_public_path__ + "static/media/IEEE International Workshop on Digital Privacy for.c4a82828.pdf";